/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Fragment } from "react";
import { Button, ErrorMessage } from "../../../components";
import { CartSummary } from "../cartSummary/summary";

export function Shipping({ cart, form, saveShipping, post }) {
  const model = form.model;
  const render = (name) => form.renderControl(name);

  const val = form.getValue();
  const billingAddress = model.find("billingAddress");
  const shippingAddress = model.find("shippingAddress");
  const productQuantity = (cart.orderItems || [])
    .filter(item => item.orderItemType === 0)
    .reduce((sum, item) => sum + item.quantity, 0);

  const next = (e) => {
    form.validateForm(e, () => {
      saveShipping();
    });
  };

  if (billingAddress) {
    billingAddress.disableValidators = val.useSameAddress;
  }

  shippingAddress.disableValidators = false;

  if (val.shippingMethod === "Pickup" || val.shippingMethod === "0") {
    shippingAddress.disableValidators = true;
  }

  return (
    <div>
      <div className='row'>
        <div className='col-md-9'>
          <form>
            <h3>Delivery Method</h3>
            {render("shippingMethod")}
            {val.shippingMethod !== "" && (
              <Fragment>
                {val.shippingMethod === "Standard" && (
                  <Fragment>
                    <h3> Delivery Date & Time</h3>
                    <div className='row'>
                      <div className='col-12 col-md-6'>
                        {render("deliveryPickupDate")}
                      </div>
                      <div className='col-12 col-md-6'>
                        {render("deliveryPickupTime")}
                      </div>
                    </div>

                    <h3> Enter Delivery Instructions</h3>
                    {render("deliveryInstructions")}

                    <h3>Shipping Address</h3>
                    <Address form={form} addressModel={shippingAddress} />
                  </Fragment>
                )}

                {val.shippingMethod === "Pickup" && productQuantity >= 10 && (
                  <Fragment>
                    <h3> Pickup Date & Location </h3>
                    <p style={{ fontSize: '0.9rem', color: '#555' }}>Pickup available after 10:00 AM</p>

                    <div className='row'>
                      <div className='col-12 col-md-6'>
                        {render("deliveryPickupDate")}
                      </div>
                      <div className='col-12 col-md-6'>
                        {render("location")}
                      </div>
                    </div>
                  </Fragment>
                )}
                {val.shippingMethod === "Pickup" && productQuantity < 10 && (
                  <p style={{ color: 'red' }}>A minimum of 10 items is required to place an order.</p>
                )}

                {productQuantity >= 10 && (
                  <Fragment>
                    <h3>Customer Information</h3>
                    {!val.useSameAddress && (
                      <Address form={form} addressModel={billingAddress} />
                    )}
                  </Fragment>
                )}
              </Fragment>
            )}
          </form>
        </div>

        <div className='col-md-3'>
          <CartSummary cart={cart} />
        </div>
      </div>

      {val.shippingMethod !== "" && productQuantity >= 10 && (
        <Fragment>
          <div className='form__actions'>
            <Button onClick={next} status={post.status}>
              PLACE ORDER
            </Button>
            <ErrorMessage
              errors={form.errors}
              summaryMessage='Please review the errors.'
            />
            <ErrorMessage errors={post.errors} />
          </div>
        </Fragment>
      )}
    </div>
  );
}

function Address({ form, addressModel }) {
  const render = (name) => form.renderControl(name, addressModel);
  return (
    <div>
      <div className='row'>
        <div className='col-12'>{render("contactName")}</div>
      </div>
      <div className='row'>
        <div className='col-12'>{render("stationName")}</div>
      </div>
      <div className='row'>
        <div className='col-12'>{render("department")}</div>
      </div>
      <div className='row'>
        <div className='col-12 col-md-6'>{render("email")}</div>
        <div className='col-12 col-md-6'>{render("mobile")}</div>
      </div>
    </div>
  );
}
